export enum EnvironmentEnum {
  Development = 'dev',
  Test = 'test',
  Acceptance = 'acc',
  Production = 'prod',
}
